import { compareAsc, isSameDay } from 'date-fns';

let isDateBefore = (date, compareDate) => {
  return compareDate && compareAsc(date, compareDate) === 1 && !isSameDay(date, compareDate);
};

export default isDateBefore;
